const fonts = {

  mainTitle: {
    fontSize: 16,
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    fontWeight: 'bold',
    color: '#000000'
  },
  
  description: {
    fontSize: 12,
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    color: '#AAAAAA',
    lineHeight: 1.5
  },

  xAxis: {
    fontSize: 12,
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    color: '#AAAAAA',
    margin: 2
  },
  
  xAxisSmall: {
    fontSize: 10,
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    color: '#CCCCCC',
    margin: 2
  },

  yAxis: {
    fontSize: 10,
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    color: '#000000',
    margin: 2
  },
  
  yAxisMain: {
    fontSize: 9,
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    color: '#CCCCCC'
  }
};

export default fonts;



// WEBPACK FOOTER //
// ./src/styleguide/fonts.js